export enum DocumentStatusEnum {
  pending = 'pending',
  uploaded = 'uploaded',
  accepted = 'accepted',
  rejected = 'rejected',
  terminated = 'terminated',
}

export type DocumentStatus = 'pending' | 'accepted' | 'rejected' | 'terminated' | 'uploaded';
